// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__2mjzl","input":"styles_input__3HeAs","filterBtn":"styles_filterBtn__3NLE-"};